import './FirefoxSlidesWarningBanner.css';

/** True for desktop/mobile Firefox (Gecko), not Chrome impersonators. */
export function isFirefoxBrowser() {
  if (typeof navigator === 'undefined') return false;
  return /\bFirefox\/\d/i.test(navigator.userAgent || '');
}

/**
 * Shown on the main control panel in Firefox: Google Slides embeds often hit a
 * third-party cookie wall; Chromium-based browsers usually avoid it.
 */
export default function FirefoxSlidesWarningBanner() {
  if (!isFirefoxBrowser()) return null;
  return (
    <div className="firefox-slides-warning" role="status">
      <p className="firefox-slides-warning__title">
        <i className="fa-brands fa-firefox-browser" aria-hidden="true" /> Firefox detected
      </p>
      <p className="firefox-slides-warning__body">
        Embedded Google Slides may not load here because Firefox blocks third-party cookies. For the
        most reliable preview and <strong>Audience View</strong>, use a Chromium-based browser
        (Chrome, Edge, Brave) for Deck Pack on the machine that shows slides.
      </p>
    </div>
  );
}
